// extracted by mini-css-extract-plugin
export default {"cart_total":"CartTotals_cart_total__z0jlZ","cart_total_item":"CartTotals_cart_total_item__kMCv0"};